export const isVehicleMode = () => {
    const url = new URL(window.location.href);
    return url.pathname === '/vehicleNotifications';
};
